import moment from "moment";
import navRoutes from "Navigation/NavRoutes";
import React, { Component } from "react";
import styled from "styled-components";
import { Fonts, Metrics } from "Themes";
import { mobileSize } from "Themes/Metrics";
import AppConfig from "Config/AppConfig";

const MainContainer = styled.div`
  padding: 20px 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const CommentsContainer = styled.div`
  padding: 20px 20%;
  margin-top: 10px;
  @media ${mobileSize.large} {
    padding: 10px;
  }
`;

export const CommentContainer = styled.div`
  width: 90%;
  margin-bottom: 20px;
`;

export const ProjectCommentsContainer = styled.div`
  margin-top: 50px;
  padding-top: 20px;
  border-top: solid 2px lightgray;
`;

export const Comment = styled.div`
  border: ${Metrics.borders.secondaryBorder};
  border-radius: 5px;
  padding: 20px;
  background-color: white;
`;

export const ContentText = styled.div`
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  &:hover {
    text-decoration: underline;
  }
  font-weight: ${(props) => (props.selected ? "bold" : null)};
  font-family: ${Fonts.primaryFontFamily};
`;

export const AvatarImg = styled.img`
  height: 30px;
  width: 30px;
  border-radius: 100px;
  margin-right: 10px;
`;

class CommentDetail extends Component {
  state = {
    imageError: false,
  };

  render() {
    const DefaultPic = AppConfig.NoProfilePic;
    const { key, comment, user, date, history } = this.props;
    const { imageError } = this.state;
    return (
      <>
        <CommentContainer key={key}>
          <Comment>{comment}</Comment>
          <div style={{ textAlign: "right" }}>
            <ContentText
              onClick={() => history.push(`${navRoutes.profile}/${user.id}`)}
            >
              {imageError || !user.avatar ? (
                <DefaultPic
                  style={{
                    height: 30,
                    width: 30,
                    borderRadius: 100,
                    marginRight: 10,
                  }}
                />
              ) : (
                <AvatarImg
                  src={user.avatar}
                  alt={"Not Found"}
                  onError={() => this.setState({ imageError: true })}
                />
              )}
              {user.firstName} -{" "}
              {moment(date).isValid && moment(date).fromNow()}
            </ContentText>
          </div>
        </CommentContainer>
      </>
    );
  }
}

class ProjectComments extends Component {
  render() {
    const { comments, history } = this.props;
    return (
      <MainContainer>
        {comments.map(({ comment, user, dateCreated }, key) => {
          let date = new Date(dateCreated);
          return (
            <CommentDetail
              key={key}
              comment={comment}
              user={user}
              date={date}
              history={history}
            />
          );
        })}
      </MainContainer>
    );
  }
}

export default ProjectComments;
